import React, { useState, useMemo, useContext, useEffect } from "react";
import _ from "lodash";
import useApi from "api/useApi";
import styled from "styled-components";
import UploadData from "./UploadData";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import CustomSwitch from "components/Input/CustomSwitch.js";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import { metertext } from "variables/meters";
import { getSite, getAccountMeters } from "services/ConfigServices";
import axios from "axios";

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
margin-right: auto;
margin-left: -8px;
font-size: 1.3rem;
font-weight: 500;
`;

export default function useEntitesTable(
  energy,
  parameters,
  addUserDialog,
  buttonTitle,
  dialogTitle,
  listTitle,
  forceShowAll
) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [showall, setShowall] = useState(forceShowAll || true);
  const [totalRows, setTotalRows] = useState(0);
  const [meters, setMeters] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const url = getSite(chartIdGroup, "energy." + energy + "." + parameters, showall);


  const { results, loading, error, refetch, invalidate } = useApi(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${UserService.getToken()}`,
    },
  });

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleShowAllChange = (event) => {
    setShowall(!showall);
    refetch();
    setRefresh(!refresh);
  };

  const refreshTable = () => {
    setMeters([]);
    refetch();
    setRefresh(!refresh);
  };

  // useEffect(() => {
  //   axios
  //     .get(
  //       getAccountMeters(null, energy, chartIdGroup),
  //       {
  //         headers: {
  //           Authorization: `Bearer ${UserService.getToken()}`,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       //setIndicatordata(res.data.indicators || []);
  //     })
  //     .catch(() => { });
  //   }, [chartIdGroup, refresh]);
  // // ----------------------------------------------------------

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);



  const FilterComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const UploadComponent = ({ onUpload }) => (
    <>
      <UploadButton type="button" onClick={onUpload}>
        {/*<PublishIcon fontSize="medium" />
        <UploadText>Import</UploadText>*/}
        <UploadData
          type="button"
          onClick={onUpload}
          open={open}
          handleClickOpen={handleClickOpen}
          handleClose={handleClose}
          buttonTitle={buttonTitle}
          dialogTitle={dialogTitle}
          content={addUserDialog}
        />
      </UploadButton>
    </>
  );

  const filteredItems = _.get(
    results,
    `detail.energy.${energy}.${parameters}`,
    []
  ).filter(
    (item) =>
      (item.name && typeof item.name == 'string' && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.clef && typeof item.clef == 'string' && item.clef.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.meternumber && typeof item.meternumber == 'string' && item.meternumber.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = [];
    if (parameters === 'meters') {
      exportarray = meters.map((item) => {
        let metertoexport = {};
        metertoexport[metertext.meternumber] = item.meternumber;
        metertoexport[metertext.divisionunit] = item.divisionunit === "percent" ? '%' : item.divisionunit === "sqrmtr" ? 'm²' : "Autre";
        metertoexport[metertext.divisionvalue] = new Intl.NumberFormat('fr-FR').format((item.divisionvalue).replace(',','.'));
        metertoexport[metertext.group] = showall ? groupInfoListById["" + item.groupid] : groupInfoListById["" + chartIdGroup];
        metertoexport[metertext.uuid] = item.uuid;
        return metertoexport;
      });
    }
   // console.log(energy, filterText, resetPaginationToggle, open, showall, meters, parameters, addUserDialog);

    return (
      <>
        <CustomSwitch
          style={{ margin: "10px 0 0 3px" }}
          inputTitle={"Voir tous les compteurs"}
          checkedState={showall}
          handleSwitchChange={handleShowAllChange}
          disabled={forceShowAll}
        />
        <TableName>{""}</TableName>
        <FilterComponent
          key="FilterComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {realestateupdate && addUserDialog ?
          <UploadComponent key="UploadComponent" onUpload={handleClear} /> : <></>}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!meters || meters.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, open, showall, meters, parameters]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      //onChangeRowsPerPage: handlePerRowsChange,
      //onChangePage: handlePageChange,
      //onSort: handleSort,
      loading,
      noDataComponent: <NoData></NoData>,
      paginationComponentOptions:
      {
        noRowsPerPage: false,
        rowsPerPageText: "Lignes par page",
        rangeSeparatorText: "sur",
        selectAllRowsItem: false,
        selectAllRowsItemText: "Selectionner toutes les lignes"
      }
      ,
    },
    error,
    refetch: refreshTable,
    invalidate,
    handleClose,
    showall,
    setMeters,
  };
}
